const PRICE_FRAGMENT = `
id
name
displayText
amountCents
recurringMonths
currencySymbol
currencySeparator
currencyDecimalSymbol
`;
const PUBLIC_TRACK_FRAGMENT = `
id
name
webPath
compStatus
compDate
compDateDisplay
compExtraFields {
  name
  type
  required
}
discoverable
imageUrl
features
featuredImage
registrationDescriptionHtml
idToken
description
planWeeks
trialPrice {
  id
}
activePrices {
  ${PRICE_FRAGMENT}
}
activePrice {
  ${PRICE_FRAGMENT}
  bundle {
    discounts {
      amountCents
      min
    }
    prices {
      ${PRICE_FRAGMENT}
    }
  }
}
source {
  id
  name
  slug
  imageUrl
}
`;

const PRIVATE_TRACK_FRAGMENT = `
${PUBLIC_TRACK_FRAGMENT}
workoutsCount
usersCount
`;

exports.PRICE_FRAGMENT = PRICE_FRAGMENT;
exports.PUBLIC_TRACK_FRAGMENT = PUBLIC_TRACK_FRAGMENT;
exports.PRIVATE_TRACK_FRAGMENT = PRIVATE_TRACK_FRAGMENT;
